<template>
  <div class="shipping-cost">
    <div class="navigation f--c">
      <div>
        <span class="pointer" @click="$router.replace('/')">{{ $t('Index.ShippingCost.Home') }}</span>
        <i class="iconfont icon-a-arrow-left-s-line2"></i>
        <span style="color:#8B93A3;">{{ $t('Index.ShippingCost.EstimateShippingCost') }}</span>
      </div>
    </div>
    <div class="box f--c">
      <!-- <oss-img style="width:600px;height:592px" src="https://img.kakaclo.com/web-img/index/shipping_cost_empty.png" :width="600" :height="592" /> -->
      <div class="condition">
        <div class="title f-c" style="margin: 0 auto 20px">
          <img src="https://img.kakaclo.com/web-img/image%2012820010.png" style="width:60px;height:40px;margin-right:16px">
          {{ $t('Index.ShippingCost.ShippingCalculation') }}
        </div>
        <div class="form">
          <div style="margin-bottom:14px">
            <div class="label">{{ $t('Index.ShippingCost.ShipForm') }}</div>
            <el-select style="width:360px" v-model="shippingCountry" filterable>
                <el-option :label="item.countryCn" :value="item.countryCode" v-for="item in shippingFromSelectList" :key="item.countryCode"></el-option>
            </el-select>
          </div>
          <div style="margin-bottom:14px">
            <div class="label">{{ $t('Index.ShippingCost.ShipTo') }}</div>
            <el-select style="width:360px" v-model="termini" filterable :filter-method="value=> countryFilterMethod(value)" @change="countrySelectChange">
                <el-option v-for="item in countrySelectListFilter" :key="item.countryCode" :label="item.countryNameEn" :value="item.countryCode">{{item.countryNameEn}}</el-option>
            </el-select>
          </div>
          <div style="margin-bottom:14px">
            <div class="label">{{ $t('Index.ShippingCost.Weight') }}</div>
            <div class="f--c">
              <el-input style="width: 336px;margin-right:16px" v-model="weight"></el-input>
              <span>g</span>
            </div>
          </div>
          <div style="margin-bottom:14px" class="btn">
            <el-button type="primary" style="width: 360px" round @click="submit">{{ $t('Index.ShippingCost.Inquire') }}</el-button>
          </div>
        </div>
      </div>
      <div class="table">
        <el-table
          :data="tableData"
          style="width: 100%">
          <el-table-column
            prop="channelNameEn"
            :label="$t('Index.ShippingCost.Tips1')"
            width="300">
          </el-table-column>
          <el-table-column
            prop="deliveryTime"
            :label="$t('Index.ShippingCost.DeliveryTime')"
            width="300">
          </el-table-column>
          <el-table-column
            :label="$t('Index.ShippingCost.Cost')"
            width="200">
            <template slot-scope="scope">
              {{`${scope.row.estimatedFreightCurrency} ${scope.row.estimatedFreight}`}}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <img src="https://img.kakaclo.com/web-img/shipingcostLeft.png" class="shippingCostLeft">
      <img src="https://img.kakaclo.com/web-img/shippingCostRight.png" class="shippingCostRight">
    </div>
  </div>
</template>

<script>
// import OssImg from '../../components/OssImg.vue'
import API from '@/api'
// import _ from 'lodash'

export default {
  components: {
    // OssImg
  },
  data() {
    return {
      shippingCountry: undefined,
      termini: undefined,
      tableData: [],
      shippingFromSelectList: [],
      weight: 0,
      countrySelectList: [],
      countrySelectListFilter: []
    }
  },
  created() {
    API.systemAddressInfo().then(res => {
      this.countrySelectList = res.data
      this.countrySelectListFilter = this.countrySelectList.slice()
    }).catch(result => {
      this.$message.error(result.data.message)
    })
    this.getShippingFromList()
  },
  computed: {
    searchList() {
      if (!this.shippingCountry) {
        return this.shippingFromSelectList
      } else {
        const codeArr = []
        const nameArr = []
        this.shippingFromSelectList.forEach(e => {
          if (e.code.includes(this.shippingCountry.toUpperCase())) {
            codeArr.push(e)
          } else if (e.name.toUpperCase().includes(this.shippingCountry.toUpperCase())) {
            nameArr.push(e)
          }
        })
        return [...codeArr, ...nameArr]
      }
    }
  },
  methods: {
    submit() {
      const params = {
        shippingCountry: this.shippingCountry,
        weight: this.weight,
        termini: this.termini
      }
      API.indexLookChannel(params).then(res => {
        this.tableData = res.data[0].data
        // 当物流返回时相同类型的渠道返回了多个时，只取同类型渠道中运费最低的渠道在kaka展示
        this.tableData = this.tableData.reduce((current, next) => {
          let index = current.findIndex(e => e.agingGrade === next.agingGrade)
          if (index !== -1) {
            if (current[index].estimatedFreight > next.estimatedFreight) {
              current.splice(index, 1)
              current.push(next)
            }
          } else {
            current.push(next)
          }
          return current
        }, [])
      }).catch(err => {
        this.$message.error(err.data.message)
      })
    },
    getShippingFromList() {
      API.getShippingFromList({
        pageSize: 100,
        pageNumber: 1
      }).then(result => {
        // 以国家编码去重
        const map = {}
        result.data.list.forEach(item => {
          if (item.country === 'CN' && (Object.keys(map).includes('CN_N') || Object.keys(map).includes('CN_S'))) return
          map[item.countryCode] = {
            countryCn: item.countryCn,
            countryCode: item.countryCode
          }
        })
        this.shippingFromSelectList = Object.values(map)
      })
    },
    countryFilterMethod(searchValue) {
      if (!searchValue) {
        this.countrySelectListFilter = this.countrySelectList.slice()
      } else {
        const codeArr = []
        const nameArr = []
        this.countrySelectList.forEach(e => {
          if (e.countryCode.includes(searchValue.toUpperCase())) {
            codeArr.push(e)
          } else if (e.countryNameEn.toUpperCase().includes(searchValue.toUpperCase())) {
            nameArr.push(e)
          } else if (searchValue.toUpperCase() === 'UK' && e.countryNameEn.toUpperCase().includes('ENGLAND')) {
            nameArr.push(e)
          }
        })
        this.countrySelectListFilter = [...codeArr, ...nameArr]
      }
    },
    countrySelectChange() {
      const that = this
      setTimeout(() => {
        that.countryFilterMethod('')
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.shipping-cost {
  min-width: 1000px;
  margin: 0 auto;
  position: relative;
  .navigation {
    height: 68px;
    background-color: #FFFFFF;
    >div{
      max-width: 1400px;
      padding-left: 15px;
      margin: 0 auto;
      width: 1400px;
    }
  }

  .box {
    height: 800px;
    box-sizing: border-box;
    background-color: #fff;
    padding: 60px 0;
    flex-direction: column;
    .condition {
      border: 1px solid #CDD4DD;
      width: 800px;
      margin-bottom: 30px;
      padding: 50px 0;
      z-index: 10;
      background-color: #FFFFFF;
      .title {
        font-size: 30px;
        margin-bottom: 40px;
        text-align: center;
        font-weight: bold;
      }
      .form {
        margin: 0 auto 40px;
        width: 360px;
        .label {
          height: 36px;
          line-height: 36px;
          // margin: 0 8px;
          width: 80px;
          text-align: left;
          font-weight: 500;
          font-size:16px;

        }
        /deep/.el-input__inner{
          border-radius: 0px;
        }
        .btn{
          /deep/.el-button{
            border-radius: 4px !important;
            height: 44px;
          }
        }
      }
      .button {
        margin-bottom: 24px;
      }
    }

    .table {
      width: 800px;
      z-index: 10;
    }

  }
}
.shippingCostLeft {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  z-index: 1;
}
.shippingCostRight {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  z-index: 1;
}
</style>
